import React from "react";

const Contact = () => {
  return (
    <div id="contact">
      <h3>Contact</h3>
      <a href="mailto:sipcoffeehouseartisancafe@gmail.com">
        <p>sipcoffeehouseartisancafe@gmail.com</p>
      </a>
    </div>
  );
};

export default Contact;
